import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ChangeDetectorRef, Injectable, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { ExceptionHelper } from './../../../../helper';

import { SiteSummaryService } from './site-summary.service';

import * as $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4';

@Component({
  selector: 'app-site-summary',
  templateUrl: './site-summary.component.html'
})
export class SiteSummaryComponent implements OnInit, AfterViewInit {

  applied: Boolean = true;
  activateCheckboxStatus: number;

  sites: any[];
  dataTable: any;
  res: Observable<any>;

  constructor(
    private chRef: ChangeDetectorRef,
    private exception: ExceptionHelper,
    private http: HttpClient,
    private router: Router,
    private siteSummaryService: SiteSummaryService,
    private translateService: TranslateService) {
    translateService.setDefaultLang('en-us');
  }

  ngAfterViewInit() {
    this.getSummary();
  }

  ngOnInit() { }

  apply() {
    this.getSummary();
  }

  checkboxStatus(input) {
    this.applied = input.isApply;
    this.activateCheckboxStatus = input.activateCheckboxStatus;
  }

  getSummary() {
    this.siteSummaryService.getSummary(this.activateCheckboxStatus)
      .subscribe((data: any) => {
        this.applied = true;
        if ($.fn.dataTable.isDataTable('#siteDataTables')) { $('#siteDataTables').DataTable().destroy(); }

        this.sites = data.siteListModel;

        this.chRef.detectChanges();

        const table: any = $('#siteDataTables');
        this.dataTable = table.DataTable();
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
      });
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/site/site-summary/site-summary.component.ts